<!-- HEADER -->
<div
  [class.minimized-header]="minimized() === 'in' ? true : false"
  [class.maximized-header]="view() !== ViewMode.Day && minimized() === 'out' ? true : false"
  [class.maximized-header-day]="
    (view() === ViewMode.Day || view() === ViewMode.List) && minimized() === 'out' ? true : false
  "
  [class.automatic-planning]="planType() === PlanType.Automatic"
  [ngStyle]="{ 'background-image': 'url(' + dataStore.publicSettings.banner + ')' }"
>
  <div class="header-filter">
    <div class="header-content">
      <div
        class="header-content-top"
        [class.minimized-header-content-top]="minimized() === 'in' ? true : false"
        [class.maximized-header-content-top]="minimized() === 'out' ? true : false"
      >
        <div class="header-left">
          <h1 class="logo">
            <mat-icon class="logo-icon">calendar_month</mat-icon>
            Planning
          </h1>
        </div>
        <div class="header-center">
          <div class="plantype-vehicle-selection">
            <mat-form-field class="plantype mat-form-field-no-subscript white-form-field secondary-color">
              <mat-select
                [formControl]="filterForm.controls.planType"
                (selectionChange)="planTypeChanged($event.value)"
                [ngClass]="{
                  'disabled-select-white': !showDriverPlanning() && !showPlannerPlanning() && !showAutomaticPlanning(),
                }"
              >
                @if (showAutomaticPlanning()) {
                  <mat-option [value]="PlanType.Automatic">Automatisch plannen</mat-option>
                }
                <mat-option [value]="PlanType.Rides">Ritten plannen</mat-option>
                @if (showDriverPlanning() && !ignoreDriverStatus()) {
                  <mat-option [value]="PlanType.Drivers">Chauffeurs plannen</mat-option>
                }
                @if (showPlannerPlanning()) {
                  <mat-option [value]="PlanType.Planners">Planners plannen</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (planType() === PlanType.Rides) {
              <mat-form-field
                [ngClass]="{ planTypeVehicle: ignoreDriverStatus() }"
                class="vehicle mat-form-field-no-subscript white-form-field secondary-color"
              >
                <mat-select [formControl]="filterForm.controls.vehicle" required>
                  <mat-option value="all">Alle voertuigen</mat-option>
                  @for (vehicle of vehicles(); track vehicle.id) {
                    <mat-option [value]="vehicle.id">
                      <div
                        class="vehicle-dot"
                        [ngStyle]="{
                          'background-color': vehicle.calendarStyle.color,
                        }"
                      ></div>
                      {{ vehicle.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
          @if (shouldShowExportButton()) {
            <button
              mat-raised-button
              class="export-button"
              (click)="exportPlanning()"
              [class.spinner]="exporting()"
              [disabled]="exporting()"
            >
              <mat-icon>print</mat-icon>
              <span class="span-fix">Planning exporteren</span>
            </button>
          }
        </div>
        <div class="header-right">
          <div class="toolbar-search-export">
            <div class="toolbar-wrapper" [class.automatic-planning]="planType() === PlanType.Automatic">
              <div class="toolbar">
                <ng-container *ngTemplateOutlet="viewButtons"></ng-container>
              </div>
            </div>
            <mat-form-field class="search mat-form-field-no-subscript white-form-field secondary-color">
              <mat-label>Zoeken</mat-label>
              <input matInput autocomplete="off" data-lpignore="true" [formControl]="filterForm.controls.search" />
              <button
                mat-icon-button
                matSuffix
                [disableRipple]="true"
                aria-label="Zoekopdracht wissen"
                (click)="filterForm.controls.search.setValue('')"
              >
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>
            @if (shouldShowExportButton()) {
              <button
                mat-raised-button
                class="export-button"
                (click)="exportPlanning()"
                [class.spinner]="exporting()"
                [disabled]="exporting()"
              >
                <mat-icon>print</mat-icon>
                <span class="span-fix">Planning exporteren</span>
              </button>
            }
          </div>
        </div>
      </div>
      <div class="header-content-bottom">
        <div class="header-bottom">
          <div class="toolbar-date-button-wrapper">
            <div class="toolbar-date-button-spacer toolbar-date-button-spacer-toolbar">
              <div class="toolbar-wrapper" [class.automatic-planning]="planType() === PlanType.Automatic">
                <div class="toolbar">
                  <ng-container *ngTemplateOutlet="viewButtons"></ng-container>
                </div>
              </div>
            </div>
            <div class="toolbar-date-button-spacer toolbar-date-button-spacer-date">
              <div class="date">
                @if (view() !== ViewMode.List) {
                  <button
                    mat-icon-button
                    class="arrow"
                    mwlCalendarPreviousView
                    [view]="calendarView()"
                    [viewDate]="viewDate()"
                    aria-label="Vorige"
                    (viewDateChange)="viewDate.set($event); fetchEvents()"
                  >
                    <mat-icon>chevron_left</mat-icon>
                  </button>
                } @else {
                  <button mat-icon-button class="arrow" aria-label="Vorige" (click)="goToPrevious()">
                    <mat-icon>chevron_left</mat-icon>
                  </button>
                }

                <button mat-flat-button class="date-title" (click)="plannerDatepicker.open()">
                  @if (view() === ViewMode.Day || view() === ViewMode.List) {
                    <span>
                      {{ weekdays[viewBeginDate().getDay()] }}
                      {{ viewBeginDate() | date: 'd MMM y' }}
                    </span>
                  }
                  @if (view() === ViewMode.Week) {
                    <span>
                      {{ viewBeginDate() | date: 'd MMM' }} -
                      {{ viewEndDate() | date: 'd MMM y' }}
                    </span>
                  }
                  @if (view() === ViewMode.Month) {
                    <span>
                      {{ viewBeginDate() | date: 'MMMM y' }}
                    </span>
                  }
                  <mat-form-field class="title-dates">
                    <mat-datepicker #plannerDatepicker disabled="false">
                      <input
                        matInput
                        [matDatepicker]="plannerDatepicker"
                        (dateChange)="dateChanged($event.value)"
                        [ngModel]="viewDate()"
                        (ngModelChange)="viewDate.set($event)"
                        disabled
                      />
                    </mat-datepicker>
                  </mat-form-field>
                </button>
                @if (view() !== ViewMode.List) {
                  <button
                    mat-icon-button
                    class="arrow"
                    mwlCalendarNextView
                    [view]="calendarView()"
                    [viewDate]="viewDate()"
                    aria-label="Volgende"
                    (viewDateChange)="viewDate.set($event); fetchEvents()"
                  >
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                } @else {
                  <button mat-icon-button class="arrow" aria-label="Volgende" (click)="goToNext()">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                }
              </div>
            </div>
            <div class="toolbar-date-button-spacer toolbar-date-button-spacer-button">
              <button
                mat-icon-button
                class="minimalize-button"
                [attr.aria-label]="minimized() === 'in' ? 'Menu maximaliseren' : 'Menu minimaliseren'"
                (click)="toggleMenu()"
              >
                <mat-icon>{{ minimized() === 'in' ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- VEHICLE GROUP SELECTOR -->
@if (planType() === PlanType.Rides && vehicleGroups().length > 0) {
  <div class="vehicle-groups-bar">
    <div
      class="vehicle-group-item"
      role="button"
      tabindex="0"
      aria-label="Alle voertuiggroepen tonen"
      [attr.aria-pressed]="filterForm.value.vehicleGroup === 'all'"
      (click)="filterForm.patchValue({ vehicleGroup: 'all' })"
      (keydown.enter)="filterForm.patchValue({ vehicleGroup: 'all' })"
      (keydown.space)="$event.preventDefault(); filterForm.patchValue({ vehicleGroup: 'all' })"
      [class.active]="filterForm.value.vehicleGroup === 'all'"
    >
      Alle groepen
    </div>
    @for (vehicleGroup of vehicleGroups(); track vehicleGroup.id) {
      <div
        class="vehicle-group-item"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Voertuiggroep tonen: ' + vehicleGroup.name"
        [attr.aria-pressed]="filterForm.value.vehicleGroup === vehicleGroup.id"
        [class.active]="filterForm.value.vehicleGroup === vehicleGroup.id"
        (click)="filterForm.patchValue({ vehicleGroup: vehicleGroup.id })"
        (keydown.enter)="filterForm.patchValue({ vehicleGroup: vehicleGroup.id })"
        (keydown.space)="$event.preventDefault(); filterForm.patchValue({ vehicleGroup: vehicleGroup.id })"
      >
        {{ vehicleGroup.name }}
      </div>
    }
  </div>
}

<!-- Calendar -->
<div
  class="planning-main"
  [ngStyle]="planType() === PlanType.Rides && vehicleGroups().length > 0 ? { 'border-top': 'solid 2px #9d9d9d' } : {}"
  [class.maximized-has-vehicle-group-tabs]="
    vehicleGroups().length > 0 && planType() === PlanType.Rides && minimized() === 'out' ? true : false
  "
  [class.minimized-has-vehicle-group-tabs]="
    vehicleGroups().length > 0 && planType() === PlanType.Rides && minimized() === 'in' ? true : false
  "
  [class.maximized-does-not-have-vehicle-group-tabs]="
    (vehicleGroups().length <= 0 || planType() !== PlanType.Rides) && minimized() === 'out' ? true : false
  "
  [class.minimized-does-not-have-vehicle-group-tabs]="
    (vehicleGroups().length <= 0 || planType() !== PlanType.Rides) && minimized() === 'in' ? true : false
  "
>
  @if (view() === ViewMode.Week && planType() !== PlanType.Automatic && filteredEvents$ | async) {
    <div class="week-number">
      <span class="span-fix">Week</span>
      <span>{{ viewBeginDate() | date: 'w' }}</span>
    </div>
  }
  <ng-template #calendarEventTitle let-event="event">
    @if (event.meta?.ride; as ride) {
      @if (!ride.automaticallyPlanned && !ride.vehicleId) {
        <!-- Keep this aligned with the Material Icons font used by icons in event.title HTML. -->
        <span class="ride-icon ride-warning-icon">warning</span>&nbsp;
      }
    }
    <span [innerHTML]="event.title"></span>
  </ng-template>

  @if (planType() !== PlanType.Automatic && filteredEvents$ | async; as events) {
    <div class="inherit-class">
      <div class="inherit-class">
        @switch (view()) {
          <!-- MONTH -->
          @case (ViewMode.Month) {
            <div class="month-view-wrapper">
              <div class="weeks-wrapper">
                <div class="space-reserver-top"></div>
                <div class="week-wrapper">
                  @for (number of weekPerMonth(); track number) {
                    <span>{{ number }}</span>
                  }
                </div>
              </div>
              <mwl-calendar-month-view
                weekStartsOn="1"
                [viewDate]="viewDate()"
                [events]="events"
                [eventTitleTemplate]="calendarEventTitle"
                [activeDayIsOpen]="activeDayIsOpen"
                (dayClicked)="dayClicked($event.day)"
                (eventClicked)="eventClicked($event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
                class="inherit-class month-view"
              >
              </mwl-calendar-month-view>
            </div>
          }
          <!-- WEEK -->
          @case (ViewMode.Week) {
            <mwl-calendar-week-view
              [dayStartHour]="calendarStartHour()"
              [dayEndHour]="calendarEndHour()"
              weekStartsOn="1"
              [hourSegments]="hourSegments()"
              [viewDate]="viewDate()"
              [events]="events"
              [eventTitleTemplate]="calendarEventTitle"
              (eventClicked)="eventClicked($event.event)"
              (hourSegmentClicked)="newRide($event.date)"
              (eventTimesChanged)="eventTimesChanged($event)"
              class="inherit-class week-view"
            >
            </mwl-calendar-week-view>
          }
          <!-- DAY -->
          @case (ViewMode.Day) {
            @if (planType() === PlanType.Rides) {
              @if (ridesPerVehicle$ | async; as ridesPerVehicle) {
                <div class="day-view day-rides-view">
                  <div class="day-view-part1">
                    <div class="day-view-part2">
                      <div class="day-view-part3">
                        <div class="day-view-part4">
                          <div class="day-view-part5">
                            <div class="day-view-part6">
                              <div>
                                <div class="day-view-part7">
                                  @for (vehicle of filteredVehicles$ | async; track vehicle.id) {
                                    <div class="column">
                                      <p class="column-title">{{ vehicle.name }}</p>
                                      <mwl-calendar-day-view
                                        [dayStartHour]="calendarStartHour()"
                                        [dayEndHour]="calendarEndHour()"
                                        [hourSegments]="hourSegments()"
                                        [viewDate]="viewDate()"
                                        [events]="ridesPerVehicle.get(vehicle.id)"
                                        [eventTitleTemplate]="calendarEventTitle"
                                        (eventClicked)="eventClicked($event.event)"
                                        (hourSegmentClicked)="newRide($event.date, vehicle.id)"
                                        (eventTimesChanged)="eventTimesChanged($event)"
                                        class="inherit-class mwl-day-view"
                                      >
                                      </mwl-calendar-day-view>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
            @if (planType() === PlanType.Drivers || planType() === PlanType.Planners) {
              <div class="day-view day-drivers-view">
                <div class="column">
                  <mwl-calendar-day-view
                    [dayStartHour]="calendarStartHour()"
                    [dayEndHour]="calendarEndHour()"
                    [hourSegments]="hourSegments()"
                    [viewDate]="viewDate()"
                    [events]="events"
                    [eventTitleTemplate]="calendarEventTitle"
                    (eventClicked)="eventClicked($event.event)"
                    (eventTimesChanged)="eventTimesChanged($event)"
                    class="inherit-class mwl-day-view"
                  >
                  </mwl-calendar-day-view>
                </div>
              </div>
            }
          }
          <!-- LIST -->
          @case (ViewMode.List) {
            <app-planner-list-view
              [events]="filteredEvents$ | async"
              [minimized]="minimized() === 'in'"
              [vehicleGroups]="vehicleGroups().length > 0"
              (eventClicked)="eventClicked($event)"
            ></app-planner-list-view>
          }
        }
      </div>
    </div>
  } @else if (planType() === PlanType.Automatic) {
    <app-auto-plan
      [date]="viewDate()"
      [minimized]="minimized() === 'in'"
      [planTypeChanged]="planTypeChanged.bind(this)"
      [dateChanged]="dateChanged.bind(this)"
      [searchValue]="filterForm.controls.search.value"
    ></app-auto-plan>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>

@if (planType() === PlanType.Rides || planType() === PlanType.Automatic) {
  <button mat-fab extended (click)="newRide(null, null, planType() === PlanType.Automatic ? true : false)">
    <mat-icon>add</mat-icon>
    Nieuwe rit
  </button>
}

<ng-template #viewButtons>
  @if (planType() !== PlanType.Automatic) {
    <button matTooltip="Vandaag" mat-icon-button aria-label="Vandaag" mwlCalendarToday (click)="goToToday()">
      <mat-icon>today</mat-icon>
    </button>

    @if (planType() === PlanType.Rides) {
      <button
        [class.active-icon]="view() === ViewMode.List"
        mat-icon-button
        aria-label="Lijstweergave"
        (click)="setViewMode(ViewMode.List)"
        matTooltip="Lijstweergave"
      >
        <mat-icon>list_alt</mat-icon>
      </button>
    }

    <button
      [class.active-icon]="view() === ViewMode.Day"
      mat-icon-button
      aria-label="Dagweergave"
      (click)="setViewMode(ViewMode.Day)"
      matTooltip="Dagweergave"
    >
      <mat-icon>view_day</mat-icon>
    </button>

    <button
      [class.active-icon]="view() === ViewMode.Week"
      mat-icon-button
      aria-label="Weekweergave"
      (click)="setViewMode(ViewMode.Week)"
      matTooltip="Weekweergave"
    >
      <mat-icon>view_week</mat-icon>
    </button>

    <button
      [class.active-icon]="view() === ViewMode.Month"
      mat-icon-button
      aria-label="Maandweergave"
      (click)="setViewMode(ViewMode.Month)"
      matTooltip="Maandweergave"
    >
      <mat-icon>view_module</mat-icon>
    </button>
  } @else {
    <button matTooltip="Vandaag" mat-icon-button aria-label="Vandaag" mwlCalendarToday (click)="goToToday()">
      <mat-icon>today</mat-icon>
    </button>
  }
</ng-template>
